import React from 'react'
import { useUtils } from "../hooks/useUtils";
// import { ShopperContext } from '../context/shopper';
import { useTranslation } from "react-i18next";

export const FoodDetails = ({ foodFactInfo, wants12digitEAN }) => {
    // Define the structure once
  const {
    convertTo12DigitIfEAN13code,
          } = useUtils();
  const { t } = useTranslation();

  const code = convertTo12DigitIfEAN13code(foodFactInfo.code, wants12digitEAN);

  const detailsConfig = [
{ label: t('barcode.attr.code'), value: code },
{ label: t('barcode.attr.brand'), value: foodFactInfo.brands },
{ label: t('barcode.attr.categories'), value: foodFactInfo.categories },
{
  label: t('barcode.attr.food_groups'),
  value: `${foodFactInfo.food_groups || ''} ${foodFactInfo.pnns_groups_1 || ''} ${foodFactInfo.pnns_groups_2 || ''}`.trim()
},
{ label: t('barcode.attr.labels'), value: foodFactInfo.labels },
{ label: t('barcode.attr.ingredients'), value: foodFactInfo.ingredients_text },
// { label: t('barcode.attr.quantity'), value: foodFactInfo.quantity },
{ label: t('sku.quantity.label'), value: foodFactInfo.quantity },
{ label: t('barcode.attr.metric_qty'), value: foodFactInfo.product_quantity },
{ label: t('barcode.attr.metric_units'), value: foodFactInfo.product_quantity_unit },
// { label: t('barcode.attr.serving_size'), value: foodFactInfo.serving_size },
// { label: t('barcode.attr.serving_qty'), value: foodFactInfo.serving_quantity },
// { label: t('barcode.attr.srv '), value: foodFactInfo.serving_quantity_unit },
{ label: t('barcode.attr.packaging'), value: foodFactInfo.packaging_text },
{ label: t('barcode.attr.num_units'), value: foodFactInfo.packagings_n },
  ];
// <p><strong>Nutri-Score:</strong> {foodFactInfo.nutriscore_grade?.toUpperCase()}</p>
  
  return (
    <ul className="food-details-list">
      {detailsConfig.map((item, index) => (
        // Only render if the value actually exists
        item.value && (
          <li key={item.label}>
            <strong>{item.label}:</strong> {item.value}
          </li>
        )
      ))}
    </ul>
  );
};

export default FoodDetails;